import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { testimonials, faqs } from '@/mocks/manhwa';

const formSubmitAddr = 'https://readdy.ai/api/form/d9pdk9osenbniolestd0';

export default function About() {
  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebPage" data={{
        name: '关于我们 - 韩漫漫画网',
        description: '韩漫漫画网品牌介绍、用户口碑和联系方式。免费韩国漫画在线阅读平台。',
        url: 'https://bluefocugroup.cn/about',
      }} />

      <Breadcrumb items={[{ label: '关于我们' }]} />

      <main className="max-w-7xl mx-auto px-4 md:px-6 pb-16">
        {/* Brand Intro */}
        <section className="py-8 md:py-12">
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">关于我们</h1>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="text-xl font-heading font-bold text-foreground-900 mb-4">韩漫漫画网 - 您身边的韩漫阅读专家</h2>
              <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                <p>
                  韩漫漫画网创立于2020年，是国内领先的免费韩国漫画在线阅读平台。我们致力于为广大漫画爱好者提供<strong>高品质、无删减</strong>的韩漫内容，让每一位读者都能享受纯正的韩国漫画阅读体验。
                </p>
                <p>
                  我们的团队由一群热爱漫画的年轻人组成，从内容筛选到平台开发，每一个环节都倾注了我们对漫画的热爱。我们与多家韩国漫画平台建立了合作关系，确保内容的正版和高质量。
                </p>
                <p>
                  韩漫漫画网采用<strong>下拉式阅读模式</strong>，专为移动端和PC端阅读优化，提供流畅舒适的阅读体验。无论您是在通勤路上还是休闲时光，都能轻松享受韩漫带来的乐趣。
                </p>
                <p>
                  目前，平台已收录<strong>超过2000部</strong>韩国漫画作品，涵盖少年热血、少女恋爱、奇幻冒险、耽美BL、惊悚悬疑、搞笑日常等丰富分类，满足不同读者的口味需求。
                </p>
              </div>
            </div>
            <div className="aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20reading%20corner%20with%20a%20tablet%20displaying%20colorful%20comics%2C%20warm%20ambient%20lighting%2C%20bookshelf%20background%2C%20minimalist%20interior%20design%2C%20soft%20natural%20light%20from%20window%2C%20comfortable%20atmosphere%2C%20editorial%20photography%20style%2C%20Korean%20aesthetic%2C%20clean%20and%20inviting%20mood&width=800&height=600&seq=about-hanman&orientation=landscape"
                alt="韩漫漫画网 - 舒适的阅读环境"
                className="w-full h-full object-cover"
                title="韩漫漫画网 - 在线阅读体验"
              />
            </div>
          </div>
        </section>

        {/* Brand Values */}
        <section className="py-10">
          <h2 className="text-xl font-heading font-bold text-foreground-950 mb-8 text-center">我们的承诺</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { icon: 'ri-shield-check-line', title: '内容无删减', desc: '完整呈现原版故事，尊重作者和作品的完整性' },
              { icon: 'ri-image-line', title: '画质优良', desc: '高清画质保证，每一个细节都清晰可见' },
              { icon: 'ri-flashlight-line', title: '更新及时', desc: '每日更新最新资源，追更路上不落后' },
              { icon: 'ri-user-heart-line', title: '用户至上', desc: '以读者体验为核心，持续优化产品服务' },
            ].map((item, i) => (
              <div key={i} className="text-center p-6 bg-background-50 rounded-xl border border-background-200/70">
                <span className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-50 text-primary-500">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-10">
          <h2 className="text-xl font-heading font-bold text-foreground-950 mb-8 text-center">读者口碑</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {testimonials.map((t, i) => (
              <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <span key={j} className="w-4 h-4 flex items-center justify-center">
                      <i className={`text-sm ${j < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">{t.content}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="font-medium text-foreground-600">{t.name}</span>
                  <span>{t.date}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-10">
          <h2 className="text-xl font-heading font-bold text-foreground-950 mb-8 text-center">联系我们</h2>
          <div className="max-w-2xl mx-auto">
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
              <p className="text-sm text-foreground-500 mb-6 text-center">
                如果您有任何问题、建议或合作意向，欢迎通过以下表单与我们联系。我们将在24小时内回复您。
              </p>
              <form
                data-readdy-form
                className="space-y-5"
                action={formSubmitAddr}
                method="POST"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const honeypot = formData.get('phone_alt');
                  if (honeypot && (honeypot as string).trim() !== '') return;
                  try {
                    const res = await fetch(formSubmitAddr, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                    });
                    const text = await res.text();
                    let parsed: Record<string, unknown> = {};
                    try { parsed = JSON.parse(text); } catch { /* ignore */ }
                    if (res.ok && parsed?.code === 'OK') {
                      form.reset();
                      alert('提交成功！我们会尽快回复您。');
                    } else {
                      const msg = (parsed?.meta as Record<string, string>)?.message || text || '提交失败，请稍后再试';
                      alert(msg);
                    }
                  } catch {
                    alert('网络异常，请稍后再试');
                  }
                }}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input type="text" id="contact-name" name="name" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 text-sm text-foreground-950 bg-background-50 focus:outline-none focus:border-primary-300 placeholder:text-foreground-400" placeholder="请输入您的姓名" />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input type="email" id="contact-email" name="email" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 text-sm text-foreground-950 bg-background-50 focus:outline-none focus:border-primary-300 placeholder:text-foreground-400" placeholder="请输入您的邮箱" />
                  </div>
                </div>
                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                  <input type="text" id="contact-subject" name="subject" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 text-sm text-foreground-950 bg-background-50 focus:outline-none focus:border-primary-300 placeholder:text-foreground-400" placeholder="请输入主题" />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                  <textarea id="contact-message" name="message" rows={5} maxLength={500} required className="w-full px-4 py-2.5 rounded-lg border border-background-300 text-sm text-foreground-950 bg-background-50 focus:outline-none focus:border-primary-300 placeholder:text-foreground-400 resize-none" placeholder="请输入您的留言（限500字以内）"></textarea>
                  <p className="text-xs text-foreground-400 mt-1 text-right">限500字</p>
                </div>
                <input type="text" name="phone_alt" autoComplete="off" tabIndex={-1} aria-hidden="true" readOnly className="contact-honeypot" />
                <button type="submit" className="w-full py-3 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  提交留言
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* FAQ on About Page */}
        <section className="py-10">
          <h2 className="text-xl font-heading font-bold text-foreground-950 mb-8 text-center">常见问题</h2>
          <div className="max-w-3xl mx-auto space-y-3">
            {faqs.map((faq, index) => (
              <details key={index} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between p-5 text-sm font-medium text-foreground-800 list-none marker:hidden">
                  <span>{faq.question}</span>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </span>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{faq.answer}</div>
              </details>
            ))}
          </div>
        </section>
      </main>
    </>
  );
}